<template>
  <div class="row">
    <div class="col-12 mb-4" style="padding: 0;margin: 0 -6px;" v-if="teams.length && !isExternal">
      <ul class="nav nav-pills nav-fill" role="tablist">
        <li class="nav-item nav-border-override" role="presentation">
          <a
              class="nav-link active"
              id="teammates-tab"
              data-toggle="pill"
              href="#teammates"
              role="tab"
              aria-controls="teammates"
              aria-selected="true"
              @click="currentTab = 1"
          >
            Teammates
          </a>
        </li>
        <li class="nav-item nav-border-override" role="presentation">
          <a
              class="nav-link"
              id="others-tab"
              data-toggle="pill"
              href="#others"
              role="tab"
              aria-controls="others"
              aria-selected="true"
              @click="currentTab = 2"
          >
            Other People
          </a>
        </li>
      </ul>
    </div>

    <div class="col-12">
      <div class="tab-content" id="pills-tabContent">
        <div class="tab-pane fade show" :class="{active: teams.length, show: teams.length}"
             id="teammates"
             role="tabpanel"
             aria-labelledby="teammates-tab"
             v-if="currentTab == 1"
        >
          <select class="form-control wfh-control" v-if="teams.length && !isExternal" v-model="selectedTeam">
            <option v-for="(team, key) in teams" :value="key" :key="key">{{ team.name }}</option>
          </select>

          <div class="row mt-3" v-if="teams.length">
            <div style="width:100%;" v-if="showTeammatesResults">
              <StaffAvailabilityItem
                  v-for="staff in currentTeammates"
                  :staff="staff"
                  :key="`${staff.id}-name`"
                  :timezone="timezone"
              />
              <!-- && !teams[selectedTeam].teammates.length -->
              <div
                  v-if="!currentTeammates.length"
                  class="col-12 text-muted text-center"
              >
                No data available.
              </div>
            </div>

            <div class="col-12 text-muted text-center" v-else>
              Fetching your teammates...
            </div>
          </div>

          <div class="col-12 text-muted text-center" v-else>
            You're not part of any team, yet.
          </div>
        </div>


        <div
            class="tab-pane fade"
            :class="{active: teams.length === 0, show: teams.length === 0}"
            id="others"
            role="tabpanel"
            aria-labelledby="others-tab"
            v-if="currentTab == 2"
        >
          <div class="col-12 p-0">
            <div class="position-relative" v-if="!isExternal && this.hasCompany">
              <input
                  type="text"
                  placeholder="Search by name, title"
                  class="form-control mb-1 wfh-version"
                  style="padding-left: 46px !important;"
                  v-model="othersInput"
              />
              <i class="fas fa-search position-absolute" style="top: 18px;left: 18px;"></i>
            </div>
            <div class="row mt-3">
              <StaffAvailabilityItem
                  v-for="(staff, key) in others"
                  :staff="staff"
                  :key="key"
                  :timezone="timezone"
              />
              <div v-if="!others.length" class="col-12 text-muted text-center">
                No data available.
              </div>
            </div>
            <div class="d-flex justify-content-center flex-row"
                 v-if="othersPagination.next_page_url">
              <button
                  class="d-flex btn btn-link font-weight-bold text-accent"
                  style="padding: 0 !important"
                  @click="fetchOtherStaffs()"
              >
                Show more
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StaffAvailabilityItem from './StaffAvailabilityItem.vue';
import BaseAccordion from '../BaseAccordion.vue';
import _ from 'lodash';

export default {
  components: { StaffAvailabilityItem, BaseAccordion },

  props: ['timezone'],

  data () {
    return {
      hasCompany: true,
      others: [],
      teammates: {},
      othersInput: null,
      othersPagination: {
        page: 0,
        limit: 5,
        totalItem: 0,
        lastPage: 0,
        next_page_url: null,
      },
      selectedTeam: 0,

      tabs: {
        'teammates': 1,
        'others': 2,
      },

      // 1 = teammates tab
      // 2 = others tab
      currentTab: 0,
    };
  },

  computed: {
    showTeammatesResults () {
      if (!Object.keys(this.teammates).length || !this.teammates[this.selectedTeam])
        return false;

      return !!this.teammates[this.selectedTeam];
    },

    currentTeammates () {
      if (!this.showTeammatesResults) return;

      return this.teammates[this.selectedTeam];
    },

    teams () {
      return this.$store.state.userTeams;
    },

    currentUser () {
      return this.$store.state.currentUser;
    },

    isExternal () {
      return this.$store.state.isExternal;
    },
  },

  watch: {
    othersInput: _.debounce(function () {
      this.resetMetadata();
      this.fetchOtherStaffs();
    }, 500),

    async currentTab () {
      if (this.currentTab === 2) {
        if (!this.others.length) {
          await this.fetchOtherStaffs();
        }
      } else {
        if (!this.teammates[this.selectedTeam]) {
          await this.fetchTeamStaffs();
        }
      }
    },

    async selectedTeam() {
      localStorage.virtualOffice_currentTeam = this.selectedTeam;

      if (!this.teammates[this.selectedTeam]) {
        await this.fetchTeamStaffs();
      }
    }
  },

  methods: {
    async getCurrentCompanyId() {
      const res = await axios.get("/get-user-company");

      return res.data.data.id;
    },

    subscribeToUserAvailabilityEventListener(companyId) {
      window.Echo.private(`company.${companyId}`).listen(
        ".user-availability-updated",
        e => {
          this.updateStaffAvailability(e.user.id, e);
        }
      );
    },

    triggerFirstBatchOfUserAvailability() {
      if (this.teams.length === 0) {
        this.currentTab = this.tabs["others"];
      } else {
        this.currentTab = this.tabs["teammates"];
      }
    },

    resetMetadata() {
      this.others = [];
      this.othersPagination = {
        page: 0,
        limit: 5,
        totalItem: 0,
        lastPage: 0,
        next_page_url: null
      };
    },

    async fetchOtherStaffs() {
      this.othersPagination.page++;
      const includeCurrentUser = this.teams.length === 0;
      const { limit, page } = this.othersPagination;
      const q = !!this.othersInput ? this.othersInput : null;

      const res = await axios.get("/company/users-availability-list/others", {
        params: {
          include_user: includeCurrentUser ? 1 : 0,
          limit,
          page,
          q
        }
      });

      let teammates = await this.fetchFirstCheckInTimestampsFromServer(
        res.data.data
      );

      this.others = [...this.others, ...teammates];
      this.othersPagination.page = res.data.current_page;
      this.othersPagination.totalItem = res.data.total;
      this.othersPagination.lastPage = res.data.last_page;
      this.othersPagination.next_page_url = res.data.next_page_url;
    },

    async fetchTeamStaffs() {
      const teamId = this.teams[this.selectedTeam].id;
      const res = await axios.get(
        `/company/users-availability-list/group/${teamId}?limit=200`
      );

      const teammates = await this.fetchFirstCheckInTimestampsFromServer(
        res.data.data
      );

      this.$set(this.teammates, this.selectedTeam, teammates);

      this.teammates[this.selectedTeam] = this.teammates[this.selectedTeam].map(
        (teammate, key) => {
          teammate = Object.assign({}, teammate, teammates[key]);
          return teammate;
        }
      );
    },

    async fetchFirstCheckInTimestampsFromServer(teammates) {
      const teammatesIds = teammates.map(teammate => teammate.id);

      const results = await axios
        .get("/first-check-ins-by-id?ids=" + teammatesIds.join(","))
        .then(data => data.data.data);

      teammates = teammates.map(teammate => {
        teammate.firstCheckIn = !results[teammate.id]
          ? null
          : results[teammate.id];

        return teammate;
      });

      return teammates;
    },

    updateStaffAvailability(userId, data) {
      const availability = data.availability;
      const selfieImage = data.selfieImage;
      const latestCheckIn = data.latestCheckIn;

      let key;

      for (key in this.teammates) {
        this.teammates[key]
          .filter(teammate => {
            return teammate.id == userId;
          })
          .map(teammate => {
            this.$set(teammate, "availability", availability);

            if (selfieImage) {
              this.$set(teammate, "status_image", selfieImage);
            }

            if (latestCheckIn) {
              const newArray = [latestCheckIn].concat(teammate.firstCheckIn);

              this.$set(teammate, "firstCheckIn", newArray);
            }

            return teammate;
          });
      }

      this.others
        .filter(teammate => {
          return teammate.id == userId;
        })
        .map(teammate => {
          this.$set(teammate, "availability", availability);

          if (latestCheckIn) {
            const newArray = [latestCheckIn].concat(teammate.firstCheckIn);

            this.$set(teammate, "firstCheckIn", newArray);
          }

          return teammate;
        });
    }
  },

  async mounted() {
    if (localStorage.virtualOffice_currentTeam) {
      this.selectedTeam = parseInt(localStorage.virtualOffice_currentTeam);
    } else {
      localStorage.virtualOffice_currentTeam = this.selectedTeam;
    }

    this.getCurrentCompanyId()
      .then(this.subscribeToUserAvailabilityEventListener)
      .catch(e => {
        this.hasCompany = false;
      })
      .then(this.triggerFirstBatchOfUserAvailability);
  }
};
</script>

<style lang="scss">
.nav-border-override .active {
  border: none;
  background-color: #fff !important;
  border-bottom: #ff375e 4px solid;
}

.nav-pills .nav-link, .nav-pills .nav-link:hover {
  color: #313131 !important;
  font-family: 'Lato', sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  text-align: center;
}

.nav-pills .nav-link.active {
  background-color: #fff !important;
  border-radius: 0 !important;
  font-weight: bold;
  color: #313131 !important;
}

.wfh-control {
  color: #808fa4;
  border-radius: 0;
}
</style>
